import { render, staticRenderFns } from "./OnGoingSchemeForm.vue?vue&type=template&id=47c36660"
import script from "./OnGoingSchemeForm.vue?vue&type=script&lang=js"
export * from "./OnGoingSchemeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports